/* eslint-disable max-classes-per-file */
import { QuestionModel } from 'core/models/elements/questions/question.abstract.model';
import { TagModel } from 'core/models/elements/components/tag.model';

/**
 * @class Defines a hole question.
 */
export class HoleQuestionModel extends QuestionModel {
  /**
   * @constructor Creates an instance of a hole question built from an original data from the API.
   * @param {bo} bo is the basic object come from API.
   */
  constructor(bo) {
    super(bo);
    this.answerContent = bo.answer_content;
    this.answers = bo.answers?.map((answer) => new TagModel(answer));
    this.displayMode = bo.display_mode;
  }
}
